import React from "react";

function Recruiters(props) {
  const { appl } = props;
  return (
    <div className="col-xl-12">
      <div className="card">
        <div className="card-body">
          <h5 className="card-title">Recruiters</h5>
          <hr />
          <div className="row separate-row">
            <div className="col-sm-6">
              <div className="job-icon pb-2">
                <div className="d-flex align-items-center mb-1">
                  <h2 className="mb-0 lh-1">{appl?.total_recruiter ?? 0}</h2>
                  <i
                    className={`fa-solid ms-3 ${appl?.total_recruiter_flag}`}
                  ></i>
                </div>
                <div className="fs-14 d-block mb-2">Total Recruiters</div>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="job-icon pb-2">
                <div>
                  <div className="d-flex align-items-center mb-1">
                    <h2 className="mb-0 lh-1">{appl?.active_recruiter ?? 0}</h2>
                    <i
                      className={`fa-solid ms-3 ${appl?.active_recruiter_flag}`}
                    ></i>
                  </div>
                  <div className="fs-14 d-block mb-2">Active Recruiter</div>
                </div>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="job-icon pt-2">
                <div>
                  <div className="d-flex align-items-center mb-1">
                    <h2 className="mb-0 lh-1">{appl?.today_recruiter ?? 0}</h2>
                    <i
                      className={`fa-solid ms-3 ${appl?.today_recruiter_flag}`}
                    ></i>
                  </div>
                  <div className="fs-14 d-block mb-2">Today Recruiter</div>
                </div>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="job-icon pt-2">
                <div>
                  <div className="d-flex align-items-center mb-1">
                    <h2 className="mb-0 lh-1">{appl?.job_by_recruiter ?? 0}</h2>
                    <i
                      className={`fa-solid ms-3 ${appl?.job_by_recruiter_flag}`}
                    ></i>
                  </div>
                  <div className="fs-14 d-block mb-2">Jobs By Recruiters</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Recruiters;
